interface VisibleFilterIdsInput {
  previousIds: number[];
  availableIds: number[];
  storedIds: number[];
  defaultIds: number[];
  preselectedIds: number[];
  hasSeeded: boolean;
}

// Seeding runs once: after that an empty list is the user's choice, not a list still waiting to load.
export const resolveVisibleFilterIds = ({
  previousIds,
  availableIds,
  storedIds,
  defaultIds,
  preselectedIds,
  hasSeeded
}: VisibleFilterIdsInput): number[] => {
  const validPreviousIds = previousIds.filter((id) => availableIds.includes(id));
  if (hasSeeded || validPreviousIds.length > 0) {
    return validPreviousIds;
  }

  const validStoredIds = storedIds
    .filter((id, index) => storedIds.indexOf(id) === index)
    .filter((id) => availableIds.includes(id));
  if (validStoredIds.length > 0) {
    return validStoredIds;
  }

  return [
    ...defaultIds,
    ...preselectedIds.filter((id) => !defaultIds.includes(id))
  ];
};
